import React, { useEffect, useState } from "react";

// components
import PageLayout from "../components/PageLayout";
import YearCard from "../components/YearCard";
import ExlusiveShelfPieChart from "../components/charts/ExclusiveShelfPieChart";
import AuthorsPieChart from "../components/charts/AuthorsPieChart";
import MostReadAuthorsChart from "../components/charts/MostReadAuthorsChart";
import LastReadBooks from "../components/LastReadBooks";
import MyRatingChart from "../components/charts/MyRatingChart";

// services
import axiosInstance from "../api/apiClient";

// images
const noCover = 'https://dryofg8nmyqjw.cloudfront.net/images/no-cover.png';

const Statistics = () => {
    const [library, setLibrary] = useState([]);

    useEffect(() => {
        axiosInstance.get('/getUserBooks').then((data:any) => {
            setLibrary(data);
        });

    }, []);    
    
    return (
        <PageLayout
            headerText={`Statistics`}
            type="books"
        >
           <YearCard library={library}/>
           
            <div className="grid md:grid-cols-2 grid-cols-1 mt-[40px] gap-x-[40px] mb-[40px]">
                <MostReadAuthorsChart library={library}/>
                <AuthorsPieChart library={library}/>
            </div>
            <LastReadBooks library={library}/>

            <div className="grid md:grid-cols-2 grid-cols-1 mt-[40px] gap-x-[40px] mb-[40px]">
                <ExlusiveShelfPieChart library={library}/>
                <MyRatingChart library={library}/>
            </div>
        
        </PageLayout>
    );

}

export default Statistics;